/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { Configuration } from '../configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AgentResult } from '../models/agent-result';
import { AgentSessionDto } from '../models/agent-session-dto';
import { BenchmarkRunItemUpdatedMessage } from '../models/benchmark-run-item-updated-message';
import { BenchmarkRunUpdatedMessage } from '../models/benchmark-run-updated-message';
import { ConversationDto } from '../models/conversation-dto';
import { CreateResult } from '../models/create-result';
import { getnotificationsAgentCreatedSchema } from '../fn/signal-r-notifications/getnotifications-agent-created-schema';
import { GetnotificationsAgentCreatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-agent-created-schema';
import { getnotificationsAgentSessionUpdatedSchema } from '../fn/signal-r-notifications/getnotifications-agent-session-updated-schema';
import { GetnotificationsAgentSessionUpdatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-agent-session-updated-schema';
import { getnotificationsAgentUpdatedSchema } from '../fn/signal-r-notifications/getnotifications-agent-updated-schema';
import { GetnotificationsAgentUpdatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-agent-updated-schema';
import { getnotificationsBenchmarkRunItemUpdatedSchema } from '../fn/signal-r-notifications/getnotifications-benchmark-run-item-updated-schema';
import { GetnotificationsBenchmarkRunItemUpdatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-benchmark-run-item-updated-schema';
import { getnotificationsBenchmarkRunUpdatedSchema } from '../fn/signal-r-notifications/getnotifications-benchmark-run-updated-schema';
import { GetnotificationsBenchmarkRunUpdatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-benchmark-run-updated-schema';
import { getnotificationsConversationUpdatedSchema } from '../fn/signal-r-notifications/getnotifications-conversation-updated-schema';
import { GetnotificationsConversationUpdatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-conversation-updated-schema';
import { getnotificationsLlmStreamChunkSchema } from '../fn/signal-r-notifications/getnotifications-llm-stream-chunk-schema';
import { GetnotificationsLlmStreamChunkSchema$Params } from '../fn/signal-r-notifications/getnotifications-llm-stream-chunk-schema';
import { getnotificationsLlmStreamCompletedSchema } from '../fn/signal-r-notifications/getnotifications-llm-stream-completed-schema';
import { GetnotificationsLlmStreamCompletedSchema$Params } from '../fn/signal-r-notifications/getnotifications-llm-stream-completed-schema';
import { getnotificationsLlmStreamFailedSchema } from '../fn/signal-r-notifications/getnotifications-llm-stream-failed-schema';
import { GetnotificationsLlmStreamFailedSchema$Params } from '../fn/signal-r-notifications/getnotifications-llm-stream-failed-schema';
import { getnotificationsSubscriptionPlanChangedSchema } from '../fn/signal-r-notifications/getnotifications-subscription-plan-changed-schema';
import { GetnotificationsSubscriptionPlanChangedSchema$Params } from '../fn/signal-r-notifications/getnotifications-subscription-plan-changed-schema';
import { getnotificationsTestCreatedSchema } from '../fn/signal-r-notifications/getnotifications-test-created-schema';
import { GetnotificationsTestCreatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-test-created-schema';
import { getnotificationsTestRunUpdatedSchema } from '../fn/signal-r-notifications/getnotifications-test-run-updated-schema';
import { GetnotificationsTestRunUpdatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-test-run-updated-schema';
import { getnotificationsTestUpdatedSchema } from '../fn/signal-r-notifications/getnotifications-test-updated-schema';
import { GetnotificationsTestUpdatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-test-updated-schema';
import { getnotificationsToolCreatedSchema } from '../fn/signal-r-notifications/getnotifications-tool-created-schema';
import { GetnotificationsToolCreatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-tool-created-schema';
import { getnotificationsToolUpdatedSchema } from '../fn/signal-r-notifications/getnotifications-tool-updated-schema';
import { GetnotificationsToolUpdatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-tool-updated-schema';
import { getnotificationsUsageUpdatedSchema } from '../fn/signal-r-notifications/getnotifications-usage-updated-schema';
import { GetnotificationsUsageUpdatedSchema$Params } from '../fn/signal-r-notifications/getnotifications-usage-updated-schema';
import { GetToolResult } from '../models/get-tool-result';
import { LlmStreamChunkMessage } from '../models/llm-stream-chunk-message';
import { LlmStreamCompletedMessage } from '../models/llm-stream-completed-message';
import { LlmStreamFailedMessage } from '../models/llm-stream-failed-message';
import { SubscriptionPlanChangedMessage } from '../models/subscription-plan-changed-message';
import { TestDto } from '../models/test-dto';
import { TestRunSummary } from '../models/test-run-summary';
import { UsageUpdatedMessage } from '../models/usage-updated-message';

@Injectable({ providedIn: 'root' })
export class SignalRNotificationsService extends BaseService {
  constructor(config: Configuration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getnotificationsUsageUpdatedSchema()` */
  static readonly GetnotificationsUsageUpdatedSchemaPath = '/api/hubs/notifications/UsageUpdated';

  /**
   * UsageUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'UsageUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsUsageUpdatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsUsageUpdatedSchema$Response(params?: GetnotificationsUsageUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<UsageUpdatedMessage>> {
    const obs = getnotificationsUsageUpdatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * UsageUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'UsageUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsUsageUpdatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsUsageUpdatedSchema(params?: GetnotificationsUsageUpdatedSchema$Params, context?: HttpContext): Observable<UsageUpdatedMessage> {
    const resp = this.getnotificationsUsageUpdatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<UsageUpdatedMessage>): UsageUpdatedMessage => r.body)
    );
  }

  /** Path part for operation `getnotificationsSubscriptionPlanChangedSchema()` */
  static readonly GetnotificationsSubscriptionPlanChangedSchemaPath = '/api/hubs/notifications/SubscriptionPlanChanged';

  /**
   * SubscriptionPlanChanged event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'SubscriptionPlanChanged' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsSubscriptionPlanChangedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsSubscriptionPlanChangedSchema$Response(params?: GetnotificationsSubscriptionPlanChangedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<SubscriptionPlanChangedMessage>> {
    const obs = getnotificationsSubscriptionPlanChangedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * SubscriptionPlanChanged event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'SubscriptionPlanChanged' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsSubscriptionPlanChangedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsSubscriptionPlanChangedSchema(params?: GetnotificationsSubscriptionPlanChangedSchema$Params, context?: HttpContext): Observable<SubscriptionPlanChangedMessage> {
    const resp = this.getnotificationsSubscriptionPlanChangedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<SubscriptionPlanChangedMessage>): SubscriptionPlanChangedMessage => r.body)
    );
  }

  /** Path part for operation `getnotificationsLlmStreamChunkSchema()` */
  static readonly GetnotificationsLlmStreamChunkSchemaPath = '/api/hubs/notifications/LlmStreamChunk';

  /**
   * LlmStreamChunk event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'LlmStreamChunk' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsLlmStreamChunkSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsLlmStreamChunkSchema$Response(params?: GetnotificationsLlmStreamChunkSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<LlmStreamChunkMessage>> {
    const obs = getnotificationsLlmStreamChunkSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * LlmStreamChunk event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'LlmStreamChunk' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsLlmStreamChunkSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsLlmStreamChunkSchema(params?: GetnotificationsLlmStreamChunkSchema$Params, context?: HttpContext): Observable<LlmStreamChunkMessage> {
    const resp = this.getnotificationsLlmStreamChunkSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LlmStreamChunkMessage>): LlmStreamChunkMessage => r.body)
    );
  }

  /** Path part for operation `getnotificationsLlmStreamCompletedSchema()` */
  static readonly GetnotificationsLlmStreamCompletedSchemaPath = '/api/hubs/notifications/LlmStreamCompleted';

  /**
   * LlmStreamCompleted event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'LlmStreamCompleted' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsLlmStreamCompletedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsLlmStreamCompletedSchema$Response(params?: GetnotificationsLlmStreamCompletedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<LlmStreamCompletedMessage>> {
    const obs = getnotificationsLlmStreamCompletedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * LlmStreamCompleted event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'LlmStreamCompleted' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsLlmStreamCompletedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsLlmStreamCompletedSchema(params?: GetnotificationsLlmStreamCompletedSchema$Params, context?: HttpContext): Observable<LlmStreamCompletedMessage> {
    const resp = this.getnotificationsLlmStreamCompletedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LlmStreamCompletedMessage>): LlmStreamCompletedMessage => r.body)
    );
  }

  /** Path part for operation `getnotificationsLlmStreamFailedSchema()` */
  static readonly GetnotificationsLlmStreamFailedSchemaPath = '/api/hubs/notifications/LlmStreamFailed';

  /**
   * LlmStreamFailed event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'LlmStreamFailed' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsLlmStreamFailedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsLlmStreamFailedSchema$Response(params?: GetnotificationsLlmStreamFailedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<LlmStreamFailedMessage>> {
    const obs = getnotificationsLlmStreamFailedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * LlmStreamFailed event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'LlmStreamFailed' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsLlmStreamFailedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsLlmStreamFailedSchema(params?: GetnotificationsLlmStreamFailedSchema$Params, context?: HttpContext): Observable<LlmStreamFailedMessage> {
    const resp = this.getnotificationsLlmStreamFailedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<LlmStreamFailedMessage>): LlmStreamFailedMessage => r.body)
    );
  }

  /** Path part for operation `getnotificationsAgentUpdatedSchema()` */
  static readonly GetnotificationsAgentUpdatedSchemaPath = '/api/hubs/notifications/AgentUpdated';

  /**
   * AgentUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'AgentUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsAgentUpdatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsAgentUpdatedSchema$Response(params?: GetnotificationsAgentUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentResult>> {
    const obs = getnotificationsAgentUpdatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * AgentUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'AgentUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsAgentUpdatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsAgentUpdatedSchema(params?: GetnotificationsAgentUpdatedSchema$Params, context?: HttpContext): Observable<AgentResult> {
    const resp = this.getnotificationsAgentUpdatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AgentResult>): AgentResult => r.body)
    );
  }

  /** Path part for operation `getnotificationsToolUpdatedSchema()` */
  static readonly GetnotificationsToolUpdatedSchemaPath = '/api/hubs/notifications/ToolUpdated';

  /**
   * ToolUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'ToolUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsToolUpdatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsToolUpdatedSchema$Response(params?: GetnotificationsToolUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<GetToolResult>> {
    const obs = getnotificationsToolUpdatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * ToolUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'ToolUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsToolUpdatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsToolUpdatedSchema(params?: GetnotificationsToolUpdatedSchema$Params, context?: HttpContext): Observable<GetToolResult> {
    const resp = this.getnotificationsToolUpdatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetToolResult>): GetToolResult => r.body)
    );
  }

  /** Path part for operation `getnotificationsAgentCreatedSchema()` */
  static readonly GetnotificationsAgentCreatedSchemaPath = '/api/hubs/notifications/AgentCreated';

  /**
   * AgentCreated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'AgentCreated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsAgentCreatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsAgentCreatedSchema$Response(params?: GetnotificationsAgentCreatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = getnotificationsAgentCreatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * AgentCreated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'AgentCreated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsAgentCreatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsAgentCreatedSchema(params?: GetnotificationsAgentCreatedSchema$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.getnotificationsAgentCreatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `getnotificationsToolCreatedSchema()` */
  static readonly GetnotificationsToolCreatedSchemaPath = '/api/hubs/notifications/ToolCreated';

  /**
   * ToolCreated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'ToolCreated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsToolCreatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsToolCreatedSchema$Response(params?: GetnotificationsToolCreatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = getnotificationsToolCreatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * ToolCreated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'ToolCreated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsToolCreatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsToolCreatedSchema(params?: GetnotificationsToolCreatedSchema$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.getnotificationsToolCreatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `getnotificationsTestCreatedSchema()` */
  static readonly GetnotificationsTestCreatedSchemaPath = '/api/hubs/notifications/TestCreated';

  /**
   * TestCreated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'TestCreated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsTestCreatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsTestCreatedSchema$Response(params?: GetnotificationsTestCreatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateResult>> {
    const obs = getnotificationsTestCreatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * TestCreated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'TestCreated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsTestCreatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsTestCreatedSchema(params?: GetnotificationsTestCreatedSchema$Params, context?: HttpContext): Observable<CreateResult> {
    const resp = this.getnotificationsTestCreatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CreateResult>): CreateResult => r.body)
    );
  }

  /** Path part for operation `getnotificationsTestUpdatedSchema()` */
  static readonly GetnotificationsTestUpdatedSchemaPath = '/api/hubs/notifications/TestUpdated';

  /**
   * TestUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'TestUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsTestUpdatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsTestUpdatedSchema$Response(params?: GetnotificationsTestUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<TestDto>> {
    const obs = getnotificationsTestUpdatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * TestUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'TestUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsTestUpdatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsTestUpdatedSchema(params?: GetnotificationsTestUpdatedSchema$Params, context?: HttpContext): Observable<TestDto> {
    const resp = this.getnotificationsTestUpdatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestDto>): TestDto => r.body)
    );
  }

  /** Path part for operation `getnotificationsTestRunUpdatedSchema()` */
  static readonly GetnotificationsTestRunUpdatedSchemaPath = '/api/hubs/notifications/TestRunUpdated';

  /**
   * TestRunUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'TestRunUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsTestRunUpdatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsTestRunUpdatedSchema$Response(params?: GetnotificationsTestRunUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<TestRunSummary>> {
    const obs = getnotificationsTestRunUpdatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * TestRunUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'TestRunUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsTestRunUpdatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsTestRunUpdatedSchema(params?: GetnotificationsTestRunUpdatedSchema$Params, context?: HttpContext): Observable<TestRunSummary> {
    const resp = this.getnotificationsTestRunUpdatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<TestRunSummary>): TestRunSummary => r.body)
    );
  }

  /** Path part for operation `getnotificationsAgentSessionUpdatedSchema()` */
  static readonly GetnotificationsAgentSessionUpdatedSchemaPath = '/api/hubs/notifications/AgentSessionUpdated';

  /**
   * AgentSessionUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'AgentSessionUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsAgentSessionUpdatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsAgentSessionUpdatedSchema$Response(params?: GetnotificationsAgentSessionUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentSessionDto>> {
    const obs = getnotificationsAgentSessionUpdatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * AgentSessionUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'AgentSessionUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsAgentSessionUpdatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsAgentSessionUpdatedSchema(params?: GetnotificationsAgentSessionUpdatedSchema$Params, context?: HttpContext): Observable<AgentSessionDto> {
    const resp = this.getnotificationsAgentSessionUpdatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AgentSessionDto>): AgentSessionDto => r.body)
    );
  }

  /** Path part for operation `getnotificationsConversationUpdatedSchema()` */
  static readonly GetnotificationsConversationUpdatedSchemaPath = '/api/hubs/notifications/ConversationUpdated';

  /**
   * ConversationUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'ConversationUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsConversationUpdatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsConversationUpdatedSchema$Response(params?: GetnotificationsConversationUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<ConversationDto>> {
    const obs = getnotificationsConversationUpdatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * ConversationUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'ConversationUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsConversationUpdatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsConversationUpdatedSchema(params?: GetnotificationsConversationUpdatedSchema$Params, context?: HttpContext): Observable<ConversationDto> {
    const resp = this.getnotificationsConversationUpdatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ConversationDto>): ConversationDto => r.body)
    );
  }

  /** Path part for operation `getnotificationsBenchmarkRunUpdatedSchema()` */
  static readonly GetnotificationsBenchmarkRunUpdatedSchemaPath = '/api/hubs/notifications/BenchmarkRunUpdated';

  /**
   * BenchmarkRunUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'BenchmarkRunUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsBenchmarkRunUpdatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsBenchmarkRunUpdatedSchema$Response(params?: GetnotificationsBenchmarkRunUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunUpdatedMessage>> {
    const obs = getnotificationsBenchmarkRunUpdatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * BenchmarkRunUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'BenchmarkRunUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsBenchmarkRunUpdatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsBenchmarkRunUpdatedSchema(params?: GetnotificationsBenchmarkRunUpdatedSchema$Params, context?: HttpContext): Observable<BenchmarkRunUpdatedMessage> {
    const resp = this.getnotificationsBenchmarkRunUpdatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BenchmarkRunUpdatedMessage>): BenchmarkRunUpdatedMessage => r.body)
    );
  }

  /** Path part for operation `getnotificationsBenchmarkRunItemUpdatedSchema()` */
  static readonly GetnotificationsBenchmarkRunItemUpdatedSchemaPath = '/api/hubs/notifications/BenchmarkRunItemUpdated';

  /**
   * BenchmarkRunItemUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'BenchmarkRunItemUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getnotificationsBenchmarkRunItemUpdatedSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsBenchmarkRunItemUpdatedSchema$Response(params?: GetnotificationsBenchmarkRunItemUpdatedSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<BenchmarkRunItemUpdatedMessage>> {
    const obs = getnotificationsBenchmarkRunItemUpdatedSchema(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * BenchmarkRunItemUpdated event schema (documentation only).
   *
   * ⚠️ DO NOT CALL — documentation only. Shows the shape of 'BenchmarkRunItemUpdated' event delivered via /hubs/notifications.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getnotificationsBenchmarkRunItemUpdatedSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getnotificationsBenchmarkRunItemUpdatedSchema(params?: GetnotificationsBenchmarkRunItemUpdatedSchema$Params, context?: HttpContext): Observable<BenchmarkRunItemUpdatedMessage> {
    const resp = this.getnotificationsBenchmarkRunItemUpdatedSchema$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BenchmarkRunItemUpdatedMessage>): BenchmarkRunItemUpdatedMessage => r.body)
    );
  }

}
